// Shared cascade role vocabulary (spec §9) — human labels and the
// contractor appoint-rule, used by both InviteModal (email an outsider) and
// AddMembersModal (add an existing platform user directly). Extracted so
// the two modals share one source of truth instead of duplicating the role
// data.

// Human labels for the cascade role keys returned by the invitable-projects
// source (backend role_pack or the demo seed).
export const CASCADE_ROLE_LABELS: Record<string, string> = {
  prime_lead: "Prime contractor",
  sub_lead: "Subcontractor lead",
  prime_member: "Project member",
  sub_member: "Sub-project member",
  reporter: "Reporter (field staff)",
  stratus_admin: "Stratus admin",
  funder_approver: "Funder approver",
};

export const roleLabelFor = (key: string) => CASCADE_ROLE_LABELS[key] ?? key;

// Contractor invite rule (spec §9 cascade): a contractor lead can appoint only
// people below them, and the set narrows by scope.
//  - Whole project → project member or reporter.
//  - A sub-project → reporter or sub-project member only. Project-level roles
//    are deliberately excluded: a sub-project scope carries sub-project roles,
//    not whole-project ones.
export const CONTRACTOR_WHOLE_PROJECT_ROLES = ["prime_member", "reporter"];
export const CONTRACTOR_SUBPROJECT_ROLES = ["reporter", "sub_member"];
